/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Not_EndedInputs */

const en_us2_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout has not ended yet.`)
};

const pt_br2_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ainda não terminou.`)
};

const es_419_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento todavía no terminó.`)
};

const pt_pt2_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino ainda não terminou.`)
};

const fr_fr2_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance n'est pas encore terminée.`)
};

const de_de2_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training ist noch nicht beendet.`)
};

const it_it2_workout_after_not_ended = /** @type {(inputs: Workout_After_Not_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento non è ancora terminato.`)
};

/**
* | output |
* | --- |
* | "This workout has not ended yet." |
*
* @param {Workout_After_Not_EndedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_not_ended = /** @type {((inputs?: Workout_After_Not_EndedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Not_EndedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_not_ended(inputs)
	if (locale === "es-419") return es_419_workout_after_not_ended(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_not_ended(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_not_ended(inputs)
	if (locale === "de-DE") return de_de2_workout_after_not_ended(inputs)
	if (locale === "it-IT") return it_it2_workout_after_not_ended(inputs)
	return en_us2_workout_after_not_ended(inputs)
});
export { workout_after_not_ended as "workout-after.not_ended" }